import styled from "styled-components";
import colours from "assets/colours";
import * as Card from "components/card/styles";
import queries, { devices } from "utils/responsivenessHelper";

const Right = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  padding: 0;
  margin: 0;

  ${Card.Container} {
    width: 100%;
    border-radius: 0em;
  }

  ${Card.Container} {
    ${queries.both(
      {
        marginTop: "-16%",
        width: "100%",
        fontSize: "16px",
        borderRadius: "3.5em 3.5em 0em 0em",
      },
      devices.mobile
    )}
  }
`;

const Left = styled.div`
  display: flex;
  justify-content: center;
  flex: 1;
  padding: 0;
  margin: 0;
  overflow: hidden;
  min-height: 100vh;
  background-image: url(${(props) => props.src});
  background-size: cover;
  background-position: bottom;
`;

const Container = styled.div`
  width: 100%;
  display: flex;
  min-height: 100vh;
  background: ${colours.backgroundGreen};

  ${queries.both(
    {
      flexDirection: "column",
    },
    devices.mobile
  )}
`;

const AuthImage = styled.img`
  object-fit: cover;
  width: 100%;
`;

export { Container, Left, Right, AuthImage };
